import { computeHeadingLevel } from "@testing-library/react";
import { createPortal } from "react-dom";

import { addCommas } from "@persian-tools/persian-tools";
import AddTransactionModal from "components/adminFinancial/AddTransactionModal";

export default function ComplatePriceModale({ selectedItem, setUpdaterList }) {
  console.log("selectedItem", selectedItem);
  const modalVar = (
    <div className="modal fade" id="ComolatePriceModal">
      <div className="modal-dialog modal-lg ">
        {Object.keys(selectedItem).length && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              padding: "30px",
            }}
          >
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div className="row">
              <div className="col-lg-6 d-flex my-3">
                <div className="mx-auto">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    مبلغ کل سفارش
                  </span>
                  <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                    :
                  </span>
                  <span style={{ color: "#519345", fontWeight: "bold" }}>
                    {/* {selectedItem.completePayment.complatePrice.toLocaleString()} */}
                    {addCommas(selectedItem.total_amount)} تومان
                  </span>
                </div>
              </div>
              <div className="col-lg-6 d-flex my-3">
                <div className="mx-auto">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    {" "}
                    تخفیف
                  </span>
                  <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                    :
                  </span>
                  <span style={{ color: "#ec3b50", fontWeight: "bold" }}>
                    {/* {selectedItem.completePayment.descount.toLocaleString()} */}
                    {addCommas(selectedItem.total_discount)} تومان
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 d-flex my-3">
                <div className="mx-auto">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    مبلغ پرداخت شده
                  </span>
                  <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                    :
                  </span>
                  <span style={{ color: "#519345", fontWeight: "bold" }}>
                    {/* {selectedItem.completePayment.Amountpaid.toLocaleString()} */}
                    {addCommas(selectedItem.paid_amount)}
                    تومان
                  </span>
                </div>
              </div>
              <div className="col-lg-6 d-flex my-3">
                <div className="mx-auto">
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    {" "}
                    مبلغ قابل پرداخت
                  </span>
                  <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                    :
                  </span>
                  <span style={{ color: "#ec3b50", fontWeight: "bold" }}>
                    {addCommas(
                      selectedItem.total_amount -
                        selectedItem.total_discount -
                        selectedItem.paid_amount
                    )}{" "}
                    تومان
                  </span>
                </div>
              </div>
            </div>
            <div className="row p-4">
              {/* <div className="col-8">
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                  مبلغ مانده
                </span>
                <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                  :
                </span>
                <span style={{ color: "#519345", fontWeight: "bold" }}>
                  {/* {selectedItem.completePayment.debtAmount.toLocaleString()} */}
              {/* تومان */}
              {/* </span> */}
              {/* </div> } */}
            </div>
            <div className="modal-footer">
              {/* <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#transactionModal"
              >
                افزودن تراکنش
              </button> */}
              <AddTransactionModal
                type="Order"
                maxPay={
                  selectedItem.total_amount -
                  selectedItem.total_discount -
                  selectedItem.paid_amount
                }
                selectedItem={selectedItem}
                user={{
                  value: selectedItem.user_muid.id,
                  label:
                    selectedItem.user_muid.fname +
                    " " +
                    selectedItem.user_muid.lname,
                }}
                order_id={selectedItem.id}
                setUpdaterList={setUpdaterList}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}
